// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f3ebc2f7","353":"7de5936c","703":"1df36cb6","787":"adb88153","850":"3ba8f1b6"}[chunkId] + ".chunk.js";
};